export enum Language {
  fr = "fr",
  en = "en",
}

export const languages = {
  fr: Language.fr,
};
